module.exports = __webpack_public_path__ + "img/prize_2.bc29aff5.gif";